import { Directive} from '@angular/core';
import { NG_VALIDATORS, FormControl, Validator, ValidationErrors } from '@angular/forms';

@Directive({
  selector: '[dewey-validator][ngModel]',
  providers: [{ provide: NG_VALIDATORS, useExisting: DeweyValidatorDirective, multi: true }]
})
export class DeweyValidatorDirective implements Validator {

  validate(c: FormControl): ValidationErrors {
    // console.log('dewey-validator', c.value);
    let isValid = true;
    const group = c.parent;
    if (group) {
      // group.controls['dewey_level1'].value.lvl01
      let lvl01 = group.controls['dewey_level1'] && group.controls['dewey_level1'].value ? group.controls['dewey_level1'].value.liv01 : undefined;
      let lvl02 = group.controls['dewey_level2'] && group.controls['dewey_level2'].value ? group.controls['dewey_level2'].value.liv02 : undefined;
      let lvl03 = group.controls['dewey_level3'] && group.controls['dewey_level3'].value ? group.controls['dewey_level3'].value.liv03 : undefined;
      let lvl04 = group.controls['dewey_level4'] && group.controls['dewey_level4'].value ? group.controls['dewey_level4'].value.liv04 : undefined;
      let dewey_descrizione = group.controls['dewey_descrizione'] ? group.controls['dewey_descrizione'].value : undefined;

      if ((lvl01 || lvl02 || lvl03 || lvl04) && (!dewey_descrizione)) {
        isValid = false;
      }

      // console.log('dewey-validator', lvl01, lvl02, lvl03, lvl04, dewey_descrizione);
      // console.log('dewey-validator', isValid);
    }

    const message = {
      'dewey': {
        'message': 'Dewey non completa.'
      }
    };
    return isValid ? null : message;
    // return  message;
  }
}



// WEBPACK FOOTER //
// ./src/app/helpers/validators/dewey-validator.directive.ts